import React from 'react';
import List from '@mui/material/List';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Popper from '@mui/material/Popper';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { isPDPPage } from '../../utils/helpers';
const classes = {
    popper: (theme) => ({
        [theme.breakpoints.down('xsMax')]: {
            width: '100%',
        },
    }),
};
function ZoneFilter(props) {
    const featuredPage = typeof window !== 'undefined' ? window.location.pathname.startsWith('/featured') : false;
    const { zones, activeZone, zoneSetHandler } = props;
    const [selectedZone, setSelectedZone] = React.useState('All USDA Zones');
    const [selectedZoneId, setSelectedZoneId] = React.useState('0');
    React.useEffect(() => {
        let activeDescription = 'All USDA Zones';
        zones.forEach((item) => {
            if (item.zone === activeZone) {
                activeDescription = `${activeZone} ${item.description}`;
            }
        });
        setSelectedZone(activeDescription);
        setSelectedZoneId(activeZone);
    }, [activeZone, zones]);
    const [ddActive, setddActive] = React.useState(false);
    const anchorRef = React.useRef(null);
    function handleToggle() {
        setddActive((prevOpen) => !prevOpen);
    }
    function handleClose(event) {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setddActive(false);
    }
    const prevddActive = React.useRef(ddActive);
    React.useEffect(() => {
        var _a;
        if (prevddActive.current === true && ddActive === false) {
            (_a = anchorRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        prevddActive.current = ddActive;
    }, [ddActive]);
    function zoneSelected(zoneId, changedZone) {
        if (selectedZoneId !== zoneId) {
            setSelectedZone(changedZone);
            setSelectedZoneId(zoneId);
            zoneSetHandler(zoneId);
        }
        setddActive(false);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { ref: anchorRef, id: "composition-button", onClick: handleToggle, "aria-controls": ddActive ? 'composition-menu' : undefined, "aria-expanded": ddActive ? 'true' : undefined, "aria-haspopup": "true", variant: "outlined", endIcon: ddActive ? React.createElement(ArrowDropUpIcon, { fontSize: "large" }) : React.createElement(ArrowDropDownIcon, { fontSize: "large" }), disableElevation: true, disableRipple: true, disableFocusRipple: true, sx: {
                display: (isPDPPage() || typeof window === 'undefined') && 'none',
                color: 'primary.dark',
                textAlign: 'left',
                textTransform: 'none',
                fontWeight: 'bold',
                bgcolor: 'background.default',
                borderRadius: 1.25,
                border: 1,
                position: 'relative',
                borderColor: 'secondary.contrastText',
                height: 42,
                justifyContent: 'space-between',
                width: '100%',
                p: '0px 12px',
                m: '15px 0 0 0',
                ml: {
                    sm: 2,
                },
                mt: {
                    sm: 0,
                },
                mr: {
                    sm: featuredPage ? 3.75 : 0,
                    lg: featuredPage ? 10 : undefined,
                },
                minWidth: {
                    sm: 180,
                    md: 224,
                },
                maxWidth: {
                    sm: 180,
                    md: 224,
                },
                '& .MuiButton-endIcon>*:nth-of-type(1)': {
                    fontSize: 26,
                },
            } }, selectedZone),
        React.createElement(Popper, { open: ddActive, anchorEl: anchorRef.current, role: undefined, placement: "bottom-start", transition: true, disablePortal: true, sx: classes.popper }, ({ TransitionProps, placement }) => (React.createElement(Grow, { ...TransitionProps, style: {
                transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
            } },
            React.createElement(Paper, { sx: {
                    mt: -0.125,
                    zIndex: 1,
                    bgcolor: 'background.default',
                } },
                React.createElement(ClickAwayListener, { onClickAway: handleClose },
                    React.createElement(List, { disablePadding: true, dense: true, sx: {
                            width: '100%',
                            overflow: 'scroll',
                            borderRadius: '0px 0px 5px 5px',
                            height: {
                                xsMax: 500,
                                xs: 280,
                            },
                            minWidth: {
                                xs: '100%',
                                sm: 180,
                                md: 224,
                            },
                            maxWidth: {
                                xs: '100%',
                                sm: 180,
                                md: 224,
                            },
                        } },
                        React.createElement(ListItemButton, { selected: selectedZoneId === '0', onClick: () => zoneSelected('0', 'All USDA Zones'), sx: {
                                p: '12px 10px',
                                borderLeft: 8,
                                borderLeftColor: '#808285',
                                color: '#808285',
                                bgcolor: 'background.default',
                                '&.Mui-selected': {
                                    color: 'background.default',
                                    bgcolor: '#808285',
                                    ':hover': {
                                        bgcolor: '#808285',
                                    },
                                },
                                ':hover': {
                                    color: 'background.default',
                                    bgcolor: '#808285',
                                },
                            }, onKeyDown: () => zoneSelected('0', 'All USDA Zones'), disableRipple: true, disableTouchRipple: true, disableGutters: true },
                            React.createElement(ListItemText, { sx: {
                                    mt: 0,
                                    mb: 0,
                                    '& .MuiTypography-root': {
                                        typography: {
                                            fontSize: 12,
                                            lineHeight: 1,
                                        },
                                    },
                                }, primary: "All USDA Zones" })), zones === null || zones === void 0 ? void 0 :
                        zones.map((item) => (React.createElement(ListItemButton, { sx: {
                                p: '12px 10px',
                                borderLeft: 8,
                                borderLeftColor: `${item.color}`,
                                color: '#808285',
                                bgcolor: 'background.default',
                                '&.Mui-selected': {
                                    color: 'background.default',
                                    bgcolor: item.color,
                                    ':hover': {
                                        bgcolor: item.color,
                                    },
                                },
                                ':hover': {
                                    color: 'background.default',
                                    bgcolor: item.color,
                                },
                            }, key: item.zone, selected: selectedZoneId === item.zone, onClick: () => zoneSelected(item.zone, `${item.zone} ${item.description}`), onKeyDown: () => zoneSelected(item.zone, `${item.zone} ${item.description}`), disableRipple: true, disableTouchRipple: true, disableGutters: true },
                            React.createElement(ListItemText, { sx: {
                                    mt: 0,
                                    mb: 0,
                                    '& .MuiTypography-root': {
                                        typography: {
                                            fontSize: 12,
                                            lineHeight: 1,
                                        },
                                    },
                                }, primary: `${item.zone} ${item.description}` }))))))))))));
}
export default ZoneFilter;
